/* ============================================================
   SMARTCUBES — UX-moduler
   1. Fri fragt-progressbar i kurv (drawer + kurvside)
      + forudbestillingsnote, når kurven indeholder forudbestilte varer
   2. Farvehukommelse på tværs af sider
   3. Leveringsdato-estimat med kl. 20-deadline
      (springes over, når produktsiden viser forudbestilling)
   4. Tilbage-til-toppen på opskriftssiden
   5. Antal anmeldelser i parentes med understregning
   6. Klæbende produktgalleri på desktop
   Alle moduler fejler stille — intet her må kunne blokere et køb.
   ============================================================ */
(function () {
  'use strict';

  function kr(oere) {
    var v = oere / 100;
    return v.toLocaleString('da-DK', { minimumFractionDigits: 2 }).replace(/,00$/, '') + ' kr.';
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function styleOnce(id, css) {
    if (document.getElementById(id)) return;
    var s = document.createElement('style');
    s.id = id;
    s.textContent = css;
    document.head.appendChild(s);
  }

  /* ============================================================
     1. FRI FRAGT-PROGRESSBAR + FORUDBESTILLINGSNOTE
     ============================================================ */
  (function shippingBar() {
    var THRESHOLD = 39900; // fri fragt over 399 kr.
    var EL = 'sc-ship';
    var PO = 'sc-po-cart';
    var busy = false;

    var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">' +
      '<path d="M3 7h13v8H3zM16 10h3l2 3v2h-5"/><circle cx="6.5" cy="17" r="1.6"/><circle cx="17.5" cy="17" r="1.6"/></svg>';
    var CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true">' +
      '<path d="M5 12l4 4 10-10"/></svg>';

    function css() {
      styleOnce('sc-ship-style', [
        '.sc-ship{margin:0 0 1.6rem;padding:1.4rem 1.6rem;border:1px solid rgba(42,36,30,.12);',
        'border-radius:14px;background:#F5F0E7;font-family:var(--font-body-family);box-sizing:border-box;',
        'align-self:flex-start;height:auto;min-height:0;box-shadow:0 8px 24px rgba(42,36,30,.04);}',
        '.sc-ship__text{font-size:1.35rem;line-height:1.4;color:#2A241E;margin:0 0 1rem;',
        'display:flex;align-items:center;gap:.8rem;font-weight:500;}',
        '.sc-ship__text svg{width:17px;height:17px;flex:0 0 auto;color:#C9836B;}',
        '.sc-ship__text b{font-weight:600;}',
        '.sc-ship__track{height:6px;border-radius:100px;background:rgba(42,36,30,.10);overflow:hidden;}',
        '.sc-ship__fill{display:block!important;height:100%;border-radius:100px;',
        'background:linear-gradient(90deg,#E3B5A4,#C9836B);width:0;',
        'transition:width .45s cubic-bezier(.23,1,.32,1);}',
        '.sc-ship--done{background:#F3E2DA;border-color:rgba(201,131,107,.35);}',
        '.sc-ship--done .sc-ship__fill{background:linear-gradient(90deg,#C9836B,#A8634C);}',
        '.sc-po-cart{margin:0 0 1.2rem;padding:1.2rem 1.6rem;border-radius:14px;background:#241E18;',
        'color:#EDE5D8;font-family:var(--font-body-family);font-size:1.3rem;line-height:1.45;',
        'display:flex;gap:1rem;align-items:flex-start;box-sizing:border-box;}',
        '.sc-po-cart__dot{flex:0 0 auto;width:.8rem;height:.8rem;border-radius:50%;background:#C9836B;margin-top:.45rem;}',
        '.sc-po-cart b{color:#FBF6EE;font-weight:600;}',
        '@media screen and (max-width:749px){.sc-ship{padding:1.2rem 1.3rem;margin-bottom:1.2rem;}',
        '.sc-ship__text{font-size:1.25rem;margin-bottom:.8rem;}.sc-po-cart{font-size:1.2rem;padding:1.1rem 1.3rem;}}',
        '@media (prefers-reduced-motion:reduce){.sc-ship__fill{transition:none;}}'
      ].join(''));
    }

    function targets() {
      var out = [];
      ['cart-drawer .drawer__footer', '#CartDrawer .drawer__footer', '.cart-drawer__footer',
       '#main-cart-footer .cart__footer', '.cart__footer'].forEach(function (q) {
        document.querySelectorAll(q).forEach(function (n) {
          if (out.indexOf(n) === -1) out.push(n);
        });
      });
      return out;
    }

    function paint(total) {
      css();
      var remaining = THRESHOLD - total;
      var done = remaining <= 0;
      var pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));

      targets().forEach(function (host) {
        var old = host.querySelector('.' + EL);
        if (total <= 0) { if (old) old.remove(); return; }

        var el = old;
        if (!el) {
          el = document.createElement('div');
          el.className = EL;
          el.innerHTML = '<p class="sc-ship__text"></p><div class="sc-ship__track"><div class="sc-ship__fill"></div></div>';
          host.insertBefore(el, host.firstChild);
        }

        el.classList.toggle('sc-ship--done', done);
        el.querySelector('.sc-ship__text').innerHTML = done
          ? CHECK + '<span><b>Du har fri fragt.</b></span>'
          : TRUCK + '<span>Du mangler <b>' + kr(remaining) + '</b> for at få fri fragt.</span>';

        var fill = el.querySelector('.sc-ship__fill');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { fill.style.width = pct + '%'; });
        });
      });
    }

    /* Viser en note, hvis en vare i kurven er lagt i som forudbestilling.
       Varen bærer selv teksten som linjeegenskab, så noten altid matcher
       det, der står på ordren. */
    function preorderText(cart) {
      var msg = null;
      (cart.items || []).forEach(function (it) {
        var p = it.properties || {};
        Object.keys(p).forEach(function (k) {
          if (msg || k.charAt(0) === '_') return;
          var v = String(p[k] || '');
          if (/^forudbestil/i.test(v)) msg = v;
        });
      });
      return msg;
    }

    function paintPreorder(cart) {
      css();
      var msg = preorderText(cart);
      targets().forEach(function (host) {
        var old = host.querySelector('.' + PO);
        if (!msg) { if (old) old.remove(); return; }
        var key = msg;
        if (old && old.getAttribute('data-key') === key) return;
        if (!old) {
          old = document.createElement('div');
          old.className = PO;
          old.setAttribute('role', 'note');
          host.insertBefore(old, host.firstChild);
        }
        old.setAttribute('data-key', key);
        old.innerHTML = '<span class="sc-po-cart__dot" aria-hidden="true"></span><span></span>';
        var span = old.lastChild;
        var b = document.createElement('b');
        b.textContent = msg + '.';
        span.appendChild(b);
        span.appendChild(document.createTextNode(' Vi sender hele ordren samlet, så snart bakkerne er landet på vores danske lager.'));
      });
    }

    function refresh() {
      if (busy) return;
      busy = true;
      var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
      fetch(base + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) {
          if (!c) return;
          paint(c.total_price);
          try { paintPreorder(c); } catch (e) {}
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }

    var t;
    function debounced() { clearTimeout(t); t = setTimeout(refresh, 120); }

    onReady(function () {
      refresh();
      try {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, debounced);
        }
      } catch (e) {}

      var roots = document.querySelectorAll('cart-drawer, #CartDrawer, #main-cart-footer, cart-items, #main-cart-items');
      if (roots.length) {
        var mo = new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            var n = muts[i].target;
            if (n && n.closest && (n.closest('.' + EL) || n.closest('.' + PO))) continue;
            var added = muts[i].addedNodes, own = false;
            for (var j = 0; j < added.length; j++) {
              var a = added[j];
              if (a.nodeType === 1 && (a.classList.contains(EL) || a.classList.contains(PO))) own = true;
            }
            if (own) continue;
            debounced();
            return;
          }
        });
        roots.forEach(function (r) { mo.observe(r, { childList: true, subtree: true }); });
      }

      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) debounced();
      });
    });
  })();

  /* ============================================================
     2. FARVEHUKOMMELSE
     ============================================================ */
  (function colourMemory() {
    var KEY = 'sc:colour';
    var MAXAGE = 1000 * 60 * 60 * 24 * 30;

    function save(v) {
      if (!v) return;
      try { localStorage.setItem(KEY, JSON.stringify({ v: v, t: Date.now() })); } catch (e) {}
    }

    function load() {
      try {
        var raw = localStorage.getItem(KEY);
        if (!raw) return null;
        var d = JSON.parse(raw);
        if (!d || !d.v) return null;
        if (Date.now() - (d.t || 0) > MAXAGE) return null;
        return d.v;
      } catch (e) { return null; }
    }

    onReady(function () {
      document.addEventListener('click', function (e) {
        var b = e.target.closest(
          '.scp-sw button[data-val], .scb-sw button[data-val], [data-sc-swatches] button[data-color]'
        );
        if (!b) return;
        save(b.dataset.val || b.dataset.color);
      }, { passive: true });

      if (new URLSearchParams(location.search).has('variant')) return;

      var want = load();
      if (!want) return;

      requestAnimationFrame(function () {
        var sel = '.scp-sw button[data-val="' + CSS.escape(want) + '"],' +
                  '.scb-sw button[data-val="' + CSS.escape(want) + '"]';
        var btn;
        try { btn = document.querySelector(sel); } catch (e) { return; }
        if (btn && !btn.classList.contains('active')) btn.click();
      });
    });
  })();

  /* ============================================================
     3. LEVERINGSDATO-ESTIMAT MED KL. 20-DEADLINE
     ============================================================ */
  (function deliveryEstimate() {
    var CUTOFF_HOUR = 20;
    var TRANSIT_MIN = 1;
    var TRANSIT_MAX = 3;
    var TIME_ZONE = 'Europe/Copenhagen';
    var DAYS = ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'];
    var MONTHS = ['januar', 'februar', 'marts', 'april', 'maj', 'juni',
                  'juli', 'august', 'september', 'oktober', 'november', 'december'];
    var CALENDAR =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<rect x="3" y="5" width="18" height="16" rx="2.5"/><path d="M3 10h18M8 3v4M16 3v4"/>' +
      '<circle cx="12" cy="15" r="1.6" fill="currentColor" stroke="none"/></svg>';

    function utcDate(y, m, d) { return new Date(Date.UTC(y, m, d)); }

    function addCalendarDays(from, n) {
      var d = new Date(from.getTime());
      d.setUTCDate(d.getUTCDate() + n);
      return d;
    }

    function danishNow() {
      try {
        var parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', hour12: false
        }).formatToParts(new Date());
        var v = {};
        parts.forEach(function (p) { if (p.type !== 'literal') v[p.type] = parseInt(p.value, 10); });
        return { date: utcDate(v.year, v.month - 1, v.day), hour: v.hour, minute: v.minute };
      } catch (e) {
        var n = new Date();
        return { date: utcDate(n.getFullYear(), n.getMonth(), n.getDate()), hour: n.getHours(), minute: n.getMinutes() };
      }
    }

    function easterSunday(y) {
      var a = y % 19, b = Math.floor(y / 100), c = y % 100;
      var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      var g = Math.floor((b - f + 1) / 3);
      var h = (19 * a + b - d - g + 15) % 30;
      var i = Math.floor(c / 4), k = c % 4;
      var l = (32 + 2 * e + 2 * i - h - k) % 7;
      var m = Math.floor((a + 11 * h + 22 * l) / 451);
      var month = Math.floor((h + l - 7 * m + 114) / 31);
      var day = ((h + l - 7 * m + 114) % 31) + 1;
      return utcDate(y, month - 1, day);
    }

    function dateKey(d) {
      return d.getUTCFullYear() + '-' + d.getUTCMonth() + '-' + d.getUTCDate();
    }

    function holidays(y) {
      var out = {};
      function add(d) { out[dateKey(d)] = true; }
      var easter = easterSunday(y);
      add(utcDate(y, 0, 1));
      add(addCalendarDays(easter, -3));
      add(addCalendarDays(easter, -2));
      add(addCalendarDays(easter, 1));
      if (y < 2024) add(addCalendarDays(easter, 26));
      add(addCalendarDays(easter, 39));
      add(addCalendarDays(easter, 50));
      add(utcDate(y, 11, 24));
      add(utcDate(y, 11, 25));
      add(utcDate(y, 11, 26));
      add(utcDate(y, 11, 31));
      return out;
    }

    var holidayCache = {};
    function isClosed(d) {
      var weekday = d.getUTCDay();
      if (weekday === 0 || weekday === 6) return true;
      var y = d.getUTCFullYear();
      if (!holidayCache[y]) holidayCache[y] = holidays(y);
      return !!holidayCache[y][dateKey(d)];
    }

    function nextBusinessDay(from) {
      var d = addCalendarDays(from, 1);
      while (isClosed(d)) d = addCalendarDays(d, 1);
      return d;
    }

    function addBusinessDays(from, n) {
      var d = new Date(from.getTime());
      while (n > 0) {
        d = addCalendarDays(d, 1);
        if (!isClosed(d)) n--;
      }
      return d;
    }

    function shortDate(d, includeMonth, includeYear) {
      var text = DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + '.';
      if (includeMonth) text += ' ' + MONTHS[d.getUTCMonth()];
      if (includeYear) text += ' ' + d.getUTCFullYear();
      return text;
    }

    function dateRange(from, to) {
      var sameYear = from.getUTCFullYear() === to.getUTCFullYear();
      var sameMonth = sameYear && from.getUTCMonth() === to.getUTCMonth();
      var text;
      if (sameMonth) {
        text = shortDate(from, false, false) + ' – ' + shortDate(to, true, false);
      } else if (sameYear) {
        text = shortDate(from, true, false) + ' – ' + shortDate(to, true, false);
      } else {
        text = shortDate(from, true, true) + ' – ' + shortDate(to, true, true);
      }
      return text.charAt(0).toUpperCase() + text.slice(1);
    }

    function ensureElement(host) {
      var el = document.querySelector('.sc-eta');
      if (el && document.documentElement.contains(el)) return el;

      el = document.createElement('div');
      el.className = 'sc-eta';
      el.setAttribute('aria-live', 'polite');
      el.innerHTML =
        '<span class="sc-eta__icon">' + CALENDAR + '</span>' +
        '<span class="sc-eta__content">' +
          '<span class="sc-eta__label"><i class="sc-eta__pulse" aria-hidden="true"></i>Forventet levering</span>' +
          '<strong class="sc-eta__dates"></strong>' +
          '<span class="sc-eta__note"></span>' +
        '</span>';
      host.parentNode.insertBefore(el, host.nextSibling);
      return el;
    }

    function render() {
      /* Forudbestilling: boksen er udfyldt af temaet og må ikke overskrives */
      if (document.querySelector('.sc-eta[data-preorder]')) return;

      var host = document.querySelector('.scp-strip, .scb-strip');
      if (!host) return;

      var now = danishNow();
      var beforeCutoff = now.hour < CUTOFF_HOUR;

      var dispatch = nextBusinessDay(now.date);
      if (!beforeCutoff) dispatch = nextBusinessDay(dispatch);

      var from = addBusinessDays(dispatch, TRANSIT_MIN);
      var to = addBusinessDays(dispatch, TRANSIT_MAX);

      var note = 'Bestil inden kl. 20 – vi sender pakken dagen efter.';

      var key = dateKey(from) + '|' + dateKey(to) + '|' + note;
      var el = ensureElement(host);
      if (el.dataset.etaKey === key) return;

      el.dataset.etaKey = key;
      el.querySelector('.sc-eta__dates').textContent = dateRange(from, to);
      el.querySelector('.sc-eta__note').textContent = note;
    }

    onReady(function () {
      styleOnce('sc-eta-style', [
        '.sc-eta{display:flex;align-items:center;gap:1.5rem;margin:2.2rem 0 0;padding:1.9rem 2.1rem;',
        'border:1px solid rgba(169,112,90,.34);border-radius:14px;background:#FCF7F4;color:#23201C;',
        'box-sizing:border-box;font-family:var(--font-body-family);',
        'animation:sc-eta-in .5s cubic-bezier(.22,1,.36,1) both;}',
        '@keyframes sc-eta-in{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}',
        '.sc-eta__icon{flex:0 0 auto;display:grid;place-items:center;color:#92573F;}',
        '.sc-eta__icon svg{display:block;width:2.7rem;height:2.7rem;}',
        '.sc-eta__content{display:flex;flex-direction:column;gap:.5rem;min-width:0;}',
        '.sc-eta__label{display:flex;align-items:center;gap:.8rem;font-size:1.05rem;line-height:1;',
        'letter-spacing:.18em;text-transform:uppercase;color:#92573F;font-weight:600;}',
        '.sc-eta__pulse{width:.7rem;height:.7rem;border-radius:50%;background:#A9705A;flex:0 0 auto;',
        'animation:sc-eta-pulse 2.6s ease-in-out infinite;}',
        '@keyframes sc-eta-pulse{0%,100%{opacity:1;transform:scale(1)}50%{opacity:.3;transform:scale(.72)}}',
        '.sc-eta__dates{font-family:"Fraunces",Georgia,serif;font-size:1.95rem;line-height:1.15;',
        'letter-spacing:-.028em;color:#23201C;font-weight:500;}',
        '.sc-eta__note{font-size:1.25rem;line-height:1.45;color:#6B635A;}',
        '@media screen and (max-width:749px){.sc-eta{padding:1.6rem 1.7rem;gap:1.2rem;margin-top:1.8rem;}',
        '.sc-eta__icon svg{width:2.4rem;height:2.4rem;}.sc-eta__dates{font-size:1.7rem;}',
        '.sc-eta__label{font-size:.98rem;letter-spacing:.15em;}.sc-eta__note{font-size:1.15rem;}}',
        '@media (prefers-reduced-motion:reduce){.sc-eta{animation:none}.sc-eta__pulse{animation:none}}'
      ].join(''));

      render();
      window.setInterval(render, 60000);
      window.addEventListener('pageshow', render);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) render();
      });
      document.addEventListener('shopify:section:load', render);
    });
  })();

  /* ============================================================
     4. TILBAGE TIL TOPPEN — kun paa opskriftssiden
     ============================================================ */
  (function backToTop() {
    onReady(function () {
      if (!/\/pages\/opskrifter/i.test(location.pathname)) return;

      styleOnce('sc-top-style', [
        '.sc-top{position:fixed;right:1.6rem;bottom:1.6rem;',
        'bottom:calc(1.6rem + env(safe-area-inset-bottom));',
        'z-index:50;width:4.8rem;height:4.8rem;border-radius:50%;border:none;cursor:pointer;',
        'background:#241E18;color:#FBF6EE;display:grid;place-items:center;',
        'box-shadow:0 12px 30px -12px rgba(42,36,30,.6);',
        'opacity:0;visibility:hidden;transform:translateY(12px) scale(.9);',
        'transition:opacity .25s cubic-bezier(.23,1,.32,1),transform .25s cubic-bezier(.23,1,.32,1),visibility .25s;}',
        '.sc-top.is-on{opacity:1;visibility:visible;transform:none;}',
        '.sc-top:active{transform:scale(.92);transition-duration:110ms;}',
        '.sc-top svg{width:2rem;height:2rem;}',
        '@media (prefers-reduced-motion:reduce){.sc-top{transition:opacity .01ms;}}'
      ].join(''));

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sc-top';
      btn.setAttribute('aria-label', 'Tilbage til toppen');
      btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
      document.body.appendChild(btn);

      btn.addEventListener('click', function () {
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
      });

      var ticking = false;
      window.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          btn.classList.toggle('is-on', window.scrollY > 800);
          ticking = false;
        });
      }, { passive: true });
    });
  })();

  /* ============================================================
     5. ANTAL ANMELDELSER I PARENTES MED UNDERSTREGNING
     ============================================================ */
  (function ratingCount() {
    function format() {
      var el = document.querySelector('.scp-rating');
      if (!el || el.getAttribute('data-sc-count') === 'done') return;

      var textNode = null;
      for (var i = el.childNodes.length - 1; i >= 0; i--) {
        var n = el.childNodes[i];
        if (n.nodeType === 3 && n.nodeValue.trim() && /\d/.test(n.nodeValue)) {
          textNode = n;
          break;
        }
      }
      if (!textNode) return;

      var parts = textNode.nodeValue.split('·');
      if (parts.length < 2) return;

      var score = parts[0].trim();
      var count = parts.slice(1).join('·').trim();
      if (!count) return;

      textNode.nodeValue = score + ' ';

      var span = document.createElement('span');
      span.className = 'sc-rating-count';
      span.textContent = '(' + count + ')';
      el.appendChild(span);

      el.setAttribute('data-sc-count', 'done');
    }

    onReady(function () {
      styleOnce('sc-rating-style', [
        '.sc-rating-count{text-decoration:underline;text-decoration-thickness:1px;',
        'text-underline-offset:3px;text-decoration-color:rgba(35,32,28,.45);color:inherit;}'
      ].join(''));
      format();
      window.addEventListener('load', format);
      document.addEventListener('shopify:section:load', format);
    });
  })();

  /* ============================================================
     6. KLÆBENDE PRODUKTGALLERI PÅ DESKTOP
     align-self:start er afgørende — uden den strækkes galleriet
     til hele sin grid-celle og har ingen plads at glide i.
     ============================================================ */
  (function stickyGallery() {
    onReady(function () {
      if (!document.querySelector('.scp-gallery')) return;

      styleOnce('sc-sticky-style', [
        '@media screen and (min-width:980px){',
        '.scp{overflow:visible!important;overflow-x:clip!important;}',
        '.scp-in{overflow:visible!important;}',
        '.scp-top{align-items:start!important;}',
        '.scp-gallery{align-self:start!important;position:-webkit-sticky!important;',
        'position:sticky!important;top:26px!important;}',
        '}'
      ].join(''));
    });
  })();
})();
